import { render, staticRenderFns } from "./RealnameAuth.vue?vue&type=template&id=5767f6ed&scoped=true"
import script from "./RealnameAuth.vue?vue&type=script&lang=js"
export * from "./RealnameAuth.vue?vue&type=script&lang=js"
import style0 from "./RealnameAuth.vue?vue&type=style&index=0&id=5767f6ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5767f6ed",
  null
  
)

export default component.exports